// 邀请好友
import React, { useEffect, useState, useRef, Component } from 'react';
import { useRouteMatch, useHistory, useLocation, useParams, Route } from "react-router-dom";
import {
    LaunchApp, copy, detector, ua,
    isAndroid, isIos, supportLink, inWeixin, inWeibo
} from 'web-launch-app';
import { Toast } from "antd-mobile";
import '../css/RikeAgent.scss';
import RikeService from "../services/Rike";
import { getParameter } from "../utils/func";

const RikeAgent = ({ props }) => {
    let match = useRouteMatch();
    let location = useLocation();
    let history = useHistory();
    let params = useParams();
    const APPID = 'wx754e1b2a81936e91' // appid
    console.log(match);
    console.log(location);
    console.log(history);
    console.log(params);
    const browser = {
        versions: function () {
            var u = navigator.userAgent, app = navigator.appVersion;
            return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                souyue: u.indexOf('souyue') > -1,
                superapp: u.indexOf('superapp') > -1,
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                qq: u.match(/\sQQ/i) == " qq", //是否QQ
                Safari: u.indexOf('Safari') > -1
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    const openTodoApp = () => {
        if (browser.versions.weixin) {
            if (browser.versions.ios) {
                window.location.replace("https://www.kairusi.com/thinkdiary");
            } else if (browser.versions.android) {
                window.location.replace("https://www.kairusi.com/thinkdiary");
            }
            // window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.todolist";
        }
    };
    useEffect(() => {
        document.body.style = "background: #1045F1;";
        const token = getParameter("token", location.search);
        const code = getParameter("code");
        const remark = getParameter("remark", location.search);
        console.log(remark);
        if (code && inWeixin) {
            RikeService.getWxOpenId({ share_token: token, code, remark }).then(res => {
                openTodoApp();
            }).catch(error => error.message && Toast.info(error.message))
        }
    }, []);
    const toWxpayAuth = () => {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent("http://todo.kairusi.cn" + "/web/rike/mobile/#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
      };
    return (
        <div className="invite-box agent-box">
            <img src={require("../image/rike/agent-bg.png")} alt="" className="agent-img"/>
            <div className="button" className="agent-button-box">
                <img src={require("../image/rike/agent-button.png")} alt="" className="agent-button" onClick={toWxpayAuth}/>
            </div>
        </div>
    )
};

export default RikeAgent;